const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = true;
const InitPageTest: number = 0;

const getPageInit = isDevelopment ? InitPageTest : 0;

const SiteConfig: ISiteConfig = {
    InitPage: getPageInit,
    TotalPage: 0,
    TotalPageBar: 5
} as ISiteConfig;

const IHContenidoSeguro: IIHContenidoSeguroCR = {
    init: false,
    identificationType: '',
    identification: '',
    firstName1: '',
    firstName2: '',
    lastName1: '',
    lastName2: '',
    phoneNumber: '',
    mail: '',
    birthdate: undefined,
    age: '',
    acceptTerms: false,

    plan: '',
    currency: '',
    nQuotas: '',
    nCoverage: {} as ICoveragesPlan,
    lstPlanConfig: [],
    planSelected: '',

    countryOfOrigin: '',
    province: '',
    district: '',
    canton: '',
    neighborhood: '',
    addressRisk: '',

    nationality: '',
    sex: '',
    profession: '',
    company: '',
    companyPhone: '',
    monthlyIncome: '',

    feePay: '',
    cardName: '',
    cardNumber: '',
    cardExpirationDate: '',
    cardCVV: '',
    accepTermPV: false,

    acceptSaveCard: '',
    cardType: '',
    cardCountry: '',
    issuingBank: '',
    acceptCardTerm: false,

    statusAccount: '',
    transactionId: '',
    cnpoliza: '',

    polizaid: '',
    acceptTermsFinish: false,
    oportunity: '',
    oportunityCreated: undefined,
    errorRate: false,
    messageErrorRate: '',

    catQuotas: [],
    catProvince: [],
    catCanton: [],
    catDistrict: [],
    catNeighborhood: [],
    catNationality: [],
    catProfession: [],
    catCountry: [],
    catBank: [],
    catInvalidRequirements: [],

    planConfig: {} as IPlanConfig,
    catCoverages: [],
    lstRateResumen: [],
    lstRate: [],


    paymentPV: () => {},
    downloadPolicy:() => {},
    finish: () => {},
    downloadReceipts: () => {},
    viewFinishPage: () => {},

    cclaries:'',
    cactividadIH: '',
    riskZone:'',

    souce: undefined,
}

const IHContenidoSeguroWithData: IIHContenidoSeguroCR = ({
    ...IHContenidoSeguro,
    identificationType: '1',
    firstName1: 'Eddy',
    lastName1: 'Ortiz',
    birthdate: new Date(),
    mail: 'eortiza@lafise.com',
    phoneNumber: '88888888',
    age: '33',
    identification: '9-9999-9999'
})

const setObj = () => (setData && isDevelopment) ? ({ ...IHContenidoSeguroWithData }) : ({ ...IHContenidoSeguro });

const IHContenidoSeguroDefault: IIHContenidoSeguroCR = setObj();

export { IHContenidoSeguroDefault, SiteConfig };